import React from "react";
import { useBLE } from "../../../hooks/useBle"; // Adjust path as needed

interface BiWazeTimingDisplayProps {
  isShortHeight?: boolean;
}

const BiWazeTimingDisplay = ({ isShortHeight }: BiWazeTimingDisplayProps) => {
  // Get BLE context data
  const { isConnected, manualPauseTime, manualInspTime, manualExpTime } =
    useBLE();

  // Use BLE values or default to 0.0 when disconnected/no data
  const pauseTime =
    isConnected && manualPauseTime !== undefined ? manualPauseTime : 0.0;
  const inspTime =
    isConnected && manualInspTime !== undefined ? manualInspTime : 0.0;
  const expTime =
    isConnected && manualExpTime !== undefined ? manualExpTime : 0.0;

  // Individual timing control component
  const TimingCard = ({
    value,
    label,
    color,
  }: {
    value: number;
    label: string;
    color: string;
  }) => {
    // Get colors based on connection state
    const getColors = () => {
      if (isConnected) {
        return {
          valueColor: color,
          labelColor: "#FFFFFF",
          backgroundColor: "#28272B",
        };
      } else {
        return {
          valueColor: "#666666", // Dimmed gray for disconnected
          labelColor: "#666666", // Dimmed gray for labels
          backgroundColor: "#28272B",
        };
      }
    };

    const colors = getColors();

    return (
      <div
        className="p-3 flex flex-col items-center justify-center shadow-md"
        style={{
          borderRadius: "12px",
          backgroundColor: colors.backgroundColor,
        }}
      >
        <div className="flex items-baseline">
          <span
            style={{
              fontWeight: "bold",
              fontSize: isShortHeight ? "1.5rem" : "2rem",
              color: colors.valueColor,
              transition: "color 0.3s ease",
            }}
          >
            {value.toFixed(1)}
          </span>
          <span
            className={`ml-1 ${isShortHeight ? "text-sm" : "text-lg"}`}
            style={{
              color: colors.valueColor,
              transition: "color 0.3s ease",
            }}
          >
            sec
          </span>
        </div>
        <span
          className={`${isShortHeight ? "text-xs" : "text-sm"} mt-2`}
          style={{
            color: colors.labelColor,
            transition: "color 0.3s ease",
          }}
        >
          {label}
        </span>
      </div>
    );
  };

  return (
    <div className="rounded-xl">
      <div className="grid grid-cols-3 gap-3">
        <TimingCard
          value={pauseTime}
          label="Pause Time"
          color="#00B977" // Green
        />
        <TimingCard
          value={inspTime}
          label="Insp. Time"
          color="#7BD2EC" // Cyan
        />
        <TimingCard
          value={expTime}
          label="Exp. Time"
          color="#D99D00" // Yellow/Orange
        />
      </div>
    </div>
  );
};

export default BiWazeTimingDisplay;
